import { render, staticRenderFns } from "./TasksBoard.vue?vue&type=template&id=f1e2b7d6&scoped=true&"
import script from "./TasksBoard.vue?vue&type=script&lang=js&"
export * from "./TasksBoard.vue?vue&type=script&lang=js&"
import style0 from "./TasksBoard.vue?vue&type=style&index=0&id=f1e2b7d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e2b7d6",
  null
  
)

/* custom blocks */
import block0 from "./TasksBoard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports